// axios
import axios from 'axios'

// const domain = "https://admin.uicore.co/"

export default axios.create({
  // baseURL: 'https://cors-anywhere.herokuapp.com/https://api.uicore.co/v1/',
  baseURL: 'https://api.uicore.co/v1',
  // mode: 'no-cors',
  // headers: {
  //   'Access-Control-Allow-Origin': '*',
  //   'Content-Type': 'application/json',
  // },
  // domain
  // You can add your headers here
})
